module.exports = __webpack_public_path__ + "media/homepage/apply-to-scholarships_@2x-0517202f.png";